const minerals = {
    Au: {
        name: 'Gold',
        color: 'hsl(60,100%,60%)',
        show: true
    },
    Cu: {
        name: 'Copper',
        color: 'hsl(180,80%,50%)',
        show: true
    },
    Fe: {
        name: 'Iron',
        color: 'hsl(30,50%,50%)',
        show: true
    },
    Zn: {
        name: 'Zinc',
        color: 'hsl(270,100%,70%)',
        show: true
    },
    Ag: {
        name: 'Silver',
        color: 'hsl(0,0%,100%)',
        show: true
    },
    Co: {
        name: 'Cobalt',
        color: 'hsl(260,80%,40%)',
        show: true
    },
    U: {
        name: 'Uranium',
        color: 'hsl(120,80%,60%)',
        show: true
    },
    Ni: {
        name: 'Nickel',
        color: 'hsl(220,50%,30%)',
        show: true
    },
    Mn: {
        name: 'Manganese',
        color: 'hsl(70,80%,30%)',
        show: true
    },
    // Mg: {
    //     name: 'Magnesium',
    //     color: 'hsl(280,60%,80%)'
    // },
    Pt: {
        name: 'Platinum',
        color: 'hsl(280,60%,80%)',
        show: true
    },
    // Pt: {
    //     name: 'Platinum',
    //     color: 'hsl(280,60%,80%)'
    // },
    REE: {
        name: 'Rare-earth elements',
        match: 'rare earths',
        color: 'hsl(340,90%,60%)',
        show: true
    },
    Cr: {
        name: 'chromium',
        show: false
    },
    Pd: {
        name: 'palladium',
        show: false
    },
    Pt: {
        name: 'platinum',
        show: false
    },
    W: {
        name: 'tungsten',
        show: false
    },
    Bi: {
        name: 'bismuth',
        show: false
    },
    Po: {
        name: 'polonium',
        show: false
    },
    Be: {
        name: 'beryllium',
        show: false
    },
    Sn: {
        name: 'tin',
        show: false
    },
    Mo: {
        name: 'molybdenum',
        show: false
    },
    V: {
        name: 'vanadium',
        show: false
    },
    Th: {
        name: 'thorium',
        show: false
    },

    other: {
        name: 'Other',
        color: 'hsl(35,100%,60%)',
        show: true
    },
    unknown: {
        name: 'Unknown',
        color: 'hsl(25,90%,40%)',
        show: true
    }
};
if (typeof window !== 'undefined') {
    window.minerals = minerals;
} else {
    module.exports.minerals = minerals;
}
// eval('export default minerals;');
// t
// export default minerals;

// if (typeof module !== 'undefined') {
//     module.exports.minerals = minerals;
// } else {
//     eval('export default minerals;');
//     // export default minerals;
// }
